// @ts-nocheck
//this file will remove after the core synced  with the branch
import { useMemo } from 'react';
import axios from 'axios';

import { useQueryEngine } from '../../queries/useDataEngine';
import API_ENDPOINTS from '../../const/ApiEndPoints';

const DOWNSTREAM_LINKED_ENTITIES_TABLE_QUERY_KEY = [
  'entityDetails',
  'downstreamLinkedEntitiesTable',
];

const LINKED_ENTITIES_ALL_ATTRIBUTES_QUERY_KEY = [
  'entityDetails',
  'linkedEntitiesAllAttributes',
];

const UPSTREAM_ENTITIES_QUERY_KEY = ['entityDetails', 'upstreamEntities'];

const COMMON_QUERY_OPTIONS = {
  retry: 1,
  staleTime: 5 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
  select: (response) => response?.data,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

const withParams = (queryKey, params) => {
  return [...queryKey, JSON.stringify(params || {})];
};

const getLinkedEntitiesAllAttributes = ({
  entityId,
  entityType,
  attributeId,
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.AVAILABLE_ATTRIBUTES}`,
      {
        params: {
          entity_id: entityId,
          entity_type: entityType,
          attribute_id: attributeId,
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

const getIssueTypesInfo = ({
  entityId,
  entityType,
  page,
  pageSize,
  attributeId,
  parentEntityId,
} = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DOWNSTREAM_ENTITIES}`,
      {
        params: {
          entity_id: entityId,
          entity_type: entityType,
          page,
          page_size: pageSize,
          attribute_id: attributeId,
          ...(parentEntityId ? { parent_entity_id: parentEntityId } : {}),
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

const getUpstreamEntities = ({ entityId, entityType, requestType } = {}) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_DOWNSTREAM_UPSTREAM_ENTITIES}`,
      {
        params: {
          entity_id: entityId,
          entity_type: entityType,
          request_type: requestType,
        },
        loader: false,
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const useLinkedEntitiesAllAttributesQuery = (
  params = {},
  options = {}
) => {
  const isEnabled = Boolean(options?.enabled);

  const queryKey = useMemo(() => {
    return withParams(LINKED_ENTITIES_ALL_ATTRIBUTES_QUERY_KEY, params);
  }, [JSON.stringify(params)]);

  return useQueryEngine(
    queryKey,
    () => getLinkedEntitiesAllAttributes(params),
    {
      ...COMMON_QUERY_OPTIONS,
      ...options,
      enabled: isEnabled,
    }
  );
};

export const useDownstreamLinkedEntitiesTableQuery = (
  params = {},
  options = {}
) => {
  const isEnabled = Boolean(options?.enabled);

  const queryKey = useMemo(() => {
    return withParams(DOWNSTREAM_LINKED_ENTITIES_TABLE_QUERY_KEY, params);
  }, [JSON.stringify(params)]);

  return useQueryEngine(queryKey, () => getIssueTypesInfo(params), {
    ...COMMON_QUERY_OPTIONS,
    ...options,
    enabled: isEnabled,
  });
};

export const useUpstreamEntitiesQuery = (params = {}, options = {}) => {
  const isEnabled = Boolean(options?.enabled);

  const queryKey = useMemo(() => {
    return withParams(UPSTREAM_ENTITIES_QUERY_KEY, params);
  }, [JSON.stringify(params)]);

  return useQueryEngine(queryKey, () => getUpstreamEntities(params), {
    ...COMMON_QUERY_OPTIONS,
    ...options,
    enabled: isEnabled,
  });
};
